"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteMetadataContext = void 0;

var react_1 = __importDefault(require("react"));

var CookieConsent_1 = __importDefault(require("./CookieConsent")); // context object


exports.SiteMetadataContext = react_1.default.createContext(null); // context provider

var SiteMetadataProvider = function SiteMetadataProvider(_ref) {
  var children = _ref.children,
      data = _ref.data,
      trackingId = _ref.trackingId;
  return react_1.default.createElement(exports.SiteMetadataContext.Provider, {
    value: {
      data: data,
      trackingId: trackingId
    }
  }, children, react_1.default.createElement(CookieConsent_1.default, null));
};

exports.default = SiteMetadataProvider;